import React from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';

import {
	SearchInput,
	SearchIcon,
	SearchContainer
} from './styles';

class Search extends React.Component {
	state = {
	  search: '',
	}

	searchHandler = event => this.setState({ search: event.target.value })

	keyUpHandler = event => {
	  event.persist();

	  if (event.keyCode === 13 && this.state.search.trim() !== '') {
	    this.props.textSearchHandler(this.state.search);

	    this.setState({ search: '' });
	  }
	}

	render() {
	  const { t } = this.props;

	  return (
	    <SearchContainer>
	      <SearchIcon className="icon" icon="search" />
	      <SearchInput
	        placeholder={t('header/filters/Search placeholder')}
	        value={this.state.search}
	        onChange={this.searchHandler}
	        onKeyUp={this.keyUpHandler}
	      />
	    </SearchContainer>
	  )
	}
}

Search.propTypes = {
	t: PropTypes.any,
	textSearchHandler: PropTypes.func,
}

export default translate('translations')(Search)
